
// Show bio button Montors page
const mentorsDescription = document.querySelectorAll('.bio__description');

const showBioBtn = document.querySelectorAll(".show_mentors_bio");
const hideBioBtn = document.querySelectorAll(".hide_mentors_bio");

if (mentorsDescription) {
    for (let index = 0; index < showBioBtn.length; index++) {
        showBioBtn[index].addEventListener("click", function () {
            showBioBtn[index].classList.toggle("hidden-content");
            hideBioBtn[index].classList.toggle("hidden-content");
            mentorsDescription[index].classList.toggle("fade_in");
        })

        hideBioBtn[index].addEventListener("click", function () {
            showBioBtn[index].classList.toggle("hidden-content");
            hideBioBtn[index].classList.toggle("hidden-content");
            mentorsDescription[index].classList.toggle("fade_in");
        })
    }
}

// Mentors filter
const filterItem = document.querySelector<HTMLElement>('.items');
const filterElement = document.querySelectorAll('.content__element');
const bgText = document.querySelectorAll('.content__element .bg_text');

if (filterItem) {
    window.onload = () => {
        filterItem.onclick = (selectedItem) => {
            if ((selectedItem.target as HTMLElement).classList.contains('item')) {
                filterItem.querySelector('.active').classList.remove('active');
                (selectedItem.target as HTMLElement).classList.add('active');
                let filterName = (selectedItem.target as HTMLElement).getAttribute('data-name');

                filterElement.forEach((element) => {
                    let filterEls = element.getAttribute('data-name');

                    if (filterEls == filterName) {
                        element.classList.remove('hide');
                        element.classList.add('show');

                    } else if (filterName == 'all') {
                        element.classList.remove('hide');
                        element.classList.add('show');

                        bgText.forEach(function (text) {
                            text.classList.remove('hide');
                        });

                    } else {
                        element.classList.add('hide');
                        element.classList.remove('show');

                        bgText.forEach(function (text) {
                            text.classList.add('hide');
                        });
                    }
                })
            }
        }
    }
}